import React from 'react'
import { useTranslation } from 'react-i18next'
import getLegendText from './functions/getLegendText'
import ProgressChartLegendItem from './ProgressChartLegendItem'
import { getCutscoreColors, getCutscorePercentiles, isUsingFourCategories } from '../../../util/cutscores'

export default function ProgressChartBenchmarkLegend(props) {

    const { shouldShowChart, poorCutoff, averageCutoff, goodCutoff, selectedEquating, selectedBenchmark, customBenchmarks, embedded, selectedStatePercentileCuts } = props

    const {t} = useTranslation("progress_report")

    if(!shouldShowChart) return null
    if(!poorCutoff || !averageCutoff || !goodCutoff) return null
    if(!poorCutoff.length || !averageCutoff.length || !goodCutoff.length) return null
    if(!selectedEquating) return null 
    if(embedded) return null
    const legendText = getLegendText(selectedBenchmark, customBenchmarks, t)
    
    const colors = getCutscoreColors(selectedStatePercentileCuts);

    const getLegendItems = () => {
      if (isUsingFourCategories(selectedStatePercentileCuts)) {
        const percentiles = getCutscorePercentiles(selectedStatePercentileCuts);
        const [p1, p2, p3] = percentiles;
        return (
          <>
            <ProgressChartLegendItem color={colors.GREAT} label1={t("Above")} label2={t("common:nth_pr", {percentile: p3})} />
            <ProgressChartLegendItem color={colors.GOOD} label2={`${p2} - ${p3 - 1} ${t("common:PR")}`} />
            <ProgressChartLegendItem color={colors.AVERAGE} label2={`${p1} - ${p2 - 1} ${t("common:PR")}`} />
            <ProgressChartLegendItem color={colors.POOR} label1={t("Below")} label2={t("common:nth_pr", {percentile: p1})} />
          </>
        )
      }
      return (
        <>
          <ProgressChartLegendItem color={colors.GREAT} label1={t("Above")} label2={legendText.green} />
          <ProgressChartLegendItem color={colors.GOOD} label2={legendText.yellow} />
          <ProgressChartLegendItem color={colors.POOR} label1={t("Below")} label2={legendText.red} />
        </>
      )
    }

    return (
        <div className="progressBenchmarkLegend">
            <div className='progressLegendSubheader'>
                <span>{t(legendText.title)}</span> <br /> {t(legendText.subtitle)}
            </div>
            <div className='progressLegendItems'>
              {getLegendItems()}
            </div>
        </div>
    )
}
